import React from "react";
import Header from "../components/Header/Header";
import Drawer from "../components/Drawer/Drawer";
import { Outlet } from "react-router-dom";
import {
  DRAWER_WIDTH,
  HEADER_HEIGHT,
  SIDEBAR_BG,
} from "../constants/layout";

const AppLayout = () => {
  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          height: "100vh",
          width: DRAWER_WIDTH,
          // Above header so sidebar flyouts (Unlisted, etc.) are not covered
          zIndex: 30,
          background: SIDEBAR_BG,
        }}
      >
        <Drawer />
      </div>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: DRAWER_WIDTH,
          right: 0,
          zIndex: 20,
        }}
      >
        <Header />
      </div>
      <div
        style={{
          marginLeft: DRAWER_WIDTH,
          marginTop: HEADER_HEIGHT,
          height: `calc(100vh - ${HEADER_HEIGHT}px)`,
          overflow: "auto",
          backgroundColor: "#F5F5F5",
        }}
      >
        <Outlet />
      </div>
    </div>
  );
};

export default AppLayout;
